import { render, staticRenderFns } from "./Addaffiliate.vue?vue&type=template&id=443f6047"
import script from "./Addaffiliate.vue?vue&type=script&lang=js"
export * from "./Addaffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports